const useFormatShortKey = () => {
  const func = (value?: string) => (value ? `/${value}` : '');

  return func;
};

export default useFormatShortKey;
